<span class="font-app-bold text-darkest text-sm md:text-base">{{
  "generalOptions.animalDeclaration" | translate
}}</span>
<div class="py-4 bg-white flex flex-col rounded-lg font-app-bold mx-auto mb-3 gap-4">
  @for (info of itemsToDisplay; track $index) {
    <div class="flex items-end">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ info.displayName | translate }}
        </span>
      </div>
      <span class="text-sm md:text-base font-app-bold text-darkest w-1/2 text-end">
        {{ info.value | dataNullDefault }}
      </span>
    </div>
  }
</div>
<p-divider type="solid"></p-divider>
